export class NotificationsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listLastFiveNotifications(filter) {
    return this.instance.get(`/v1/notifications/last-five`, {
      params: filter || null,
    });
  }

  listNotifications(filter) {
    return this.instance.get(`/v1/notifications`, {
      params: filter || null,
    });
  }

  markAsRead(id) {
    return this.instance.patch(`/v1/notifications/${id}`);
  }

  markAllAsRead() {
    return this.instance.patch(`/v1/notifications/`);
  }

  removeNotifications(id) {
    return this.instance.delete(`/v1/notifications/${id}`);
  }
}

export default NotificationsFactory;
